import React from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
  endDate: Date | undefined;
}

export const EndDatePresentor = ({ endDate }: IProps) => {
  const { t } = useTranslation();
  return (
    <div className='floating-input mb-1 relative'>
      <input
        type='text'
        id='periodEnd'
        className='border border-bw03 focus:outline-none font-metricR text-bw08 text-[14px] rounded-md focus:border-action03 focus:shadow-sm hover:bg-bw01 w-full p-3 h-12 '
        placeholder='transparent placeholder'
        value={endDate?.toDateString() || ''}
        disabled
      />
      <label
        id='inputLabel-periodEnd'
        htmlFor='periodEnd'
        className='absolute top-0 left-0 px-3 py-4 h-full pointer-events-none font-metricR transform origin-left transition-all duration-100 ease-in-out'
      >
        {t('TRANSACTIONS_FACELIFT.DATE_PICKER_WRAPPER.TO')}
      </label>
    </div>
  );
};
